export default __webpack_public_path__ + "static/media/whiskeyarticleimage.20342b3c.jpg";